// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"41d8eb9e","300":"4966b226","435":"2bf13ae9","608":"56cf7a87","821":"018b25c0","903":"a0903641","972":"9fc92ae2"}[chunkId] + ".chunk.js";
};